export const templateConstants = {

  GETALL_REQUEST: 'TEMPLSTES_GETALL_REQUEST',
  GETALL_SUCCESS: 'TEMPLSTES_GETALL_SUCCESS',
  GETALL_FAILURE: 'TEMPLSTES_GETALL_FAILURE'

}



// WEBPACK FOOTER //
// ./src/constants/template.constants.js